import React, { useState } from 'react';
import './reset.password.css';
import { useNavigate, useParams } from 'react-router-dom';
import { DrugExceptionsClient } from '../../client/drug-exceptions-client';
import GetLangConfig from '../../util/LangUtil';
import { TextField, Button } from '@mui/material';

interface HandleError {
    handleError: Function;
}

export default function ResetPassword(props: HandleError) {
    const history = useNavigate();
    const langConfig = GetLangConfig('preamble');
    const [email, updateEmail] = useState<string>('');
    const [password, updatePassword] = useState<string>('');
    const [password2, updatePassword2] = useState<string>('');
    const { token } = useParams();

    const resetPassword = async () => {
        if (password === '' || password2 === '') {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: ['Please fill in both password fields']
                    }
                }
            });
            return;
        }

        if (email === '') {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: ['Please fill in the email field']
                    }
                }
            });
            return;
        }

        if (password !== password2) {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: [langConfig.settings.pwdmsg6]
                    }
                }
            });
            return;
        }

        const drugExceptionsClient = new DrugExceptionsClient();
        const decodedToken = decodeURIComponent(token || '');
        try {
            const response = await drugExceptionsClient.api.post(
                '/users/resetpassword',
                {
                    password: password,
                    token: decodedToken,
                    email: email
                }
            );

            history('/login');
        } catch (error) {
            props.handleError(error);
        }
    };

    return (
        <div className="reset-password-container">
            <h1>{langConfig.resetpassword.h1}</h1>

            <TextField
                id="email"
                label={langConfig.resetpassword.lbl1}
                value={email}
                onChange={(e) => updateEmail(e.target.value)}
                error={email !== '' && !email.includes('@')} // Simple email validation
                variant="filled"
                margin="normal"
                fullWidth
            />

            <TextField
                id="password"
                label={langConfig.resetpassword.lbl2}
                value={password}
                onChange={(e) => updatePassword(e.target.value)}
                error={password !== '' && password.length < 6} // Password length validation
                variant="filled"
                margin="normal"
                type="password"
                fullWidth
            />

            <TextField
                id="password2"
                label={langConfig.settings.pwdtext3 + '*'}
                value={password2}
                onChange={(e) => updatePassword2(e.target.value)}
                error={password !== password2} // Error when passwords do not match
                variant="filled"
                margin="normal"
                type="password"
                fullWidth
            />

            <div>
                <Button
                    className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" // Custom class for your button styling
                    variant="contained"
                    color="primary"
                    onClick={resetPassword}
                    fullWidth
                >
                    {langConfig.resetpassword.lbl3}
                </Button>
            </div>
        </div>
    );
}
